import React from 'react';
import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalView = ({ view, handleChangeView }) => {
  const intl = useIntl();

  return (
    <div className="share-view share-setting form-inline">
      <Label htmlFor="view">
        <span>
          {intl.formatMessage({ defaultMessage: 'View' })}
          <HelpIcon id="share-view">
            {intl.formatMessage({ defaultMessage: 'Set an initial view for your share link. Recipients can change their personal view.' })}
          </HelpIcon>
        </span>
      </Label>
      <Input
        type="select"
        className="custom-select"
        id="view"
        name="view"
        bsSize="sm"
        value={view}
        onChange={handleChangeView}
        disabled={!canUserManageShare()}
      >
        <option value="grid">{intl.formatMessage({ defaultMessage: 'grid' })}</option>
        <option value="framed">{intl.formatMessage({ defaultMessage: 'framed' })}</option>
        <option value="masonry">{intl.formatMessage({ defaultMessage: 'masonry' })}</option>
        <option value="tile">{intl.formatMessage({ defaultMessage: 'tile' })}</option>
        <option value="slider">{intl.formatMessage({ defaultMessage: 'slider' })}</option>
      </Input>
    </div>
  );
};

ShareModalView.propTypes = {
  view: PropTypes.string.isRequired,
  handleChangeView: PropTypes.func.isRequired,
};

export default ShareModalView;
